import { Navigate } from 'react-router'

import { useInitData } from '../../../hooks'
import { withRentalPortalMockSections } from '../../../utils/rentalPortalMock'
import { getRentalPortalDefaultSubsectionName } from '../RentalPortal.utils'

function RentalPortalIndexRedirect() {
  const { sections } = useInitData()

  return (
    <Navigate
      replace
      to={getRentalPortalDefaultSubsectionName(
        withRentalPortalMockSections(sections)
      )}
    />
  )
}

export default RentalPortalIndexRedirect
